import moduleId from './module-id';

const maxRules = 1e10;

// Customize createGenerateId function for jss setup
// Remove $ in prefix to resolve jss prefix with $ sign issue
// Issue: When prefix contains $, the nested style case will lose $ thus leads to style issue
export const createGenerateId = (options = {}) => {
  let ruleCounter = 0;

  return (rule, sheet) => {
    ruleCounter += 1;

    if (ruleCounter > maxRules) {
      console.warn(`[JSS] You might have a memory leak. Rule counter is at ${ruleCounter}.`);
    }

    let jssId = '';
    let prefix = '';

    if (sheet) {
      if (sheet.options.classNamePrefix) {
        prefix = sheet.options.classNamePrefix;
        // remove generated $ sign
        prefix = prefix.replace(/\$/g, '');
      }
      if (sheet.options.jss.id != null) {
        jssId = String(sheet.options.jss.id);
      }
    }

    if (options.minify) {
      // Using "c" because a number can't be the first char in a class name.
      return `${prefix || 'c'}${moduleId}${jssId}${ruleCounter}`;
    }

    return `${prefix + rule.key}-${moduleId}${jssId ? `-${jssId}` : ''}-${ruleCounter}`;
  };
};
